import { render, staticRenderFns } from "./odr_system.vue?vue&type=template&id=045c750c&scoped=true"
import script from "./odr_system.vue?vue&type=script&lang=js"
export * from "./odr_system.vue?vue&type=script&lang=js"
import style0 from "./odr_system.vue?vue&type=style&index=0&id=045c750c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c750c",
  null
  
)

export default component.exports